import React from 'react';
import { Plus } from 'lucide-react';

/**
 * Horizontal scroll bar at the top of the feed showing users' active Swings.
 * - Current user first: + icon if no active swings, green ring if they have some
 * - Other users: green ring = unseen swings, gray ring = all seen
 */
const SwingBar = ({ swings, currentUser, users, swingUserOrder, onOpenViewer, onOpenCreate }) => {
  const swingsByUser = {};
  swings.forEach(s => {
    if (!swingsByUser[s.userId]) swingsByUser[s.userId] = [];
    swingsByUser[s.userId].push(s);
  });

  const mySwings = swingsByUser[currentUser.id] || [];

  const hasUnseen = (userId) =>
    (swingsByUser[userId] || []).some(s => !(s.viewedBy || []).includes(currentUser.id));

  // Other users in viewer order (skip current user — they're always first)
  const otherUserIds = swingUserOrder.filter(uid => uid !== currentUser.id);

  // Don't render bar if nobody (including self) has swings
  const totalSwingUsers = swingUserOrder.length;
  if (totalSwingUsers === 0 && mySwings.length === 0) {
    // Still render the + button so users can create
  }

  return (
    <div className="border-b border-gray-800">
      <div className="flex space-x-5 px-4 py-3 overflow-x-auto" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>

        {/* Current user */}
        <button
          onClick={() => mySwings.length > 0 ? onOpenViewer(currentUser.id) : onOpenCreate()}
          className="flex flex-col items-center space-y-1.5 flex-shrink-0"
        >
          <div className="relative">
            {mySwings.length > 0 ? (
              <div className="p-0.5 rounded-full bg-gradient-to-tr from-[#16a34a] to-[#0f766e]">
                <div className="p-0.5 bg-black rounded-full">
                  <img
                    src={currentUser.profilePicture}
                    alt=""
                    className="w-14 h-14 rounded-full object-cover"
                  />
                </div>
              </div>
            ) : (
              <>
                <img
                  src={currentUser.profilePicture}
                  alt=""
                  className="w-14 h-14 rounded-full object-cover border-2 border-gray-700"
                />
                <div className="absolute bottom-0 right-0 w-5 h-5 bg-[#16a34a] rounded-full flex items-center justify-center border-2 border-black">
                  <Plus className="w-3 h-3 text-pure-white" />
                </div>
              </>
            )}
          </div>
          <span className="text-xs text-gray-400 w-16 text-center truncate">My Swing</span>
        </button>

        {/* Other users */}
        {otherUserIds.map(uid => {
          const user = users.find(u => u.id === uid);
          if (!user) return null;
          const unseen = hasUnseen(uid);
          return (
            <button
              key={uid}
              onClick={() => onOpenViewer(uid)}
              className="flex flex-col items-center space-y-1.5 flex-shrink-0"
            >
              <div className={`p-0.5 rounded-full ${unseen ? 'bg-gradient-to-tr from-[#16a34a] to-[#0f766e]' : 'bg-gray-600'}`}>
                <div className="p-0.5 bg-black rounded-full">
                  <img
                    src={user.profilePicture}
                    alt=""
                    className="w-14 h-14 rounded-full object-cover"
                  />
                </div>
              </div>
              <span className="text-xs text-gray-400 w-16 text-center truncate">{user.handle}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SwingBar;
